



































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ModalPontosColeta extends Vue {
  @Prop({ required: true }) public showModal!: boolean;

  private PontosColeta = [
    {
      endereco: "Rua Clésio Migueleto 310",
      bairro: "Bairro Roosevelt",
      contato: "(34) 99677-0358 - Elson"
    },
    {
      endereco: "Rua  Sebastião Rangel 692",
      bairro: "Bairro Santa Mônica",
      contato: "(34) 99103-7557 - Cláudio"
    },
    {
      endereco: "Rua Angelica 137",
      bairro: "Bairro Cruzeiro do Sul",
      contato: "(34) 99975 2001 - Lilian"
    },
    {
      endereco: "Rua Eurico Adelino Mendes 30",
      bairro: "Bairro São Jorge",
      contato: "(34) 99654-7969 - Michel"
    },
    {
      endereco: "Av. San Marino 510",
      bairro: "Bairro Jardim Europa",
      contato: "(34) 99174-3918 - Isis"
    },
    {
      endereco: "Rua Aurora 67",
      bairro: "Bairro Cruzeiro do Sul",
      contato: "(34) 99147-5696 - Dalca"
    },
    {
      endereco: "Rua dos Anturios 85",
      bairro: "Bairro Cidade Jardim",
      contato: "(34)  99218 8928 - 11h30 em diante - Iracema"
    },
    {
      endereco: "Tapuios 1322",
      bairro: "Bairro Saraiva - Distribuidora Ipérius Beer 24h",
      contato: "(34) 99879-7900 - Cairo"
    }
  ];

  private toggleModal() {
    this.$emit("update:showModal", false);
  }
}
